<template>
	<div></div>
</template>
<script>


	import BaseVModelView from "@/core/components/BaseVModelView.vue";
    export default {
        name: "BaseFormRow",
        extends: BaseVModelView,
		props: {
			prop: String,
			propPrefix: String,
			title: String,
			titlePostfix: String,
			titlePrefix: String,
			description: String,
			placeholder: {type:String, default: "type here"},
			tooltipText: String,
			tooltipPosition: String,
			showDivider: {Boolean, default: true},
			showDividerTop: {Boolean, default: false},
			formatDataInProp: Function,
			formatDataOutProp: Function,
			isFocused: {Boolean, default: false},
			readonly: {Boolean, default: false},
			disabled: {Boolean, default: false},
		},

		watch:{
			isFocused:{
				immediate: true,
				handler(){
					this.isFocusedData = this.isFocused
				}
			}
		},

		data(){
        	return {
				isFocusedData: false
			}
		},

		methods: {
        	onFocus(){
        		if(!this.readonly && !this.disabled){
					this.isFocusedData = true
				}
				this.clearFormValidation()
				this.$emit("focus")
			},
			onBlur(){
				this.isFocusedData = false
				this.$emit("blur")
			}
		},

		computed: {
			propFull() {
				return this.propPrefix ? `${this.propPrefix}.${this.prop}` : this.prop;
			},
		},
    }
</script>

<style>

</style>

